module.exports = __webpack_public_path__ + "static/media/WoollenLandA0004.9dc42152.png";